const React = require('react');

const { createRef } = React;
const Each = require('lodash/each');
const SortBy = require('lodash/sortBy');
const IsEqual = require('lodash/isEqual');
const T = require('prop-types');
const { default: Styled } = require('styled-components');

const { default: Paper } = require('@mui/material/Paper');
const { default: FlatButton } = require('@mui/material/Button');
const { default: List } = require('@mui/material/List');
const { default: Box } = require('@mui/material/Box');
const { default: UploadIcon } = require('@mui/icons-material/Publish');
const { default: CameraIcon } = require('@mui/icons-material/CameraAlt');
const { default: StarIcon } = require('@mui/icons-material/Stars');
const { default: SettingsIcon } = require('@mui/icons-material/Settings');
const { default: RedoIcon } = require('@mui/icons-material/Redo');
const { default: OnlineIcon } = require('@mui/icons-material/Language');
const { default: ChildIcon } = require('@mui/icons-material/ChildCare');
const { default: HomeWorkIcon } = require('@mui/icons-material/HomeWork');
const { default: RightArrowIcon } = require('@mui/icons-material/ChevronRight');
const { default: LocationCity } = require('@mui/icons-material/LocationCity');
const { default: Close } = require('@mui/icons-material/Close');
const { default: TimeLapse } = require('@mui/icons-material/Timelapse');
const { default: Crop } = require('@mui/icons-material/Crop');
const { default: EditIcon } = require('@mui/icons-material/Edit');
const { default: IconButton } = require('@mui/material/IconButton');
const { default: Typography } = require('@mui/material/Typography');
const { default: FAB } = require('@mui/material/Fab');
const { transient$Props } = require('utils/styles');

const ClassListItem = require('routes/app/classes/components/ClassListItem');
const MessageBanner = require('components/MessageBanner');
const UserAchievements = require('components/UserAchievements');
const RouterLink = require('components/RouterLink');
const FocusIndicator = require('components/FocusIndicator');
const ProfilePhotoActions = require('components/ProfilePhotoActions');
const Image = require('components/Image');
const ProfileConnectionCard = require('./ProfileConnectionCard');
const NavigationButtonContainer = require('./ProfileNavigationActions');
const { ProfilePhotoFrame, ProfilePhotoEditor, ProfileConnectionsList } = require('./ProfilePhotoLayout');
const SimpleDialog = require('components/SimpleDialog');
const CropAvatarDialog = require('components/CropAvatarDialog');
const { captureProfilePhoto, fetchOriginalProfilePhotoFile, getProfilePhotoCaptureErrorMessage, validateProfilePhotoFile } = require('utils/profilePhotoCapture');
const { context } = require('app-context');

const ManageGroupsDialog = require('components/ManageGroupsDialog');
const NotifyUserDialog = require('../../containers/NotifyUserDialog');
const ChangeRoleDialog = require('../../containers/ChangeRoleDialog');

const ScrollPortal = require('components/ScrollPortal');

const Colors = require('styles/colors.json');
const MaterialMenu = require('components/MaterialMenu');
const UserBadgeComponent = require('containers/UserBadge');
const InterestPopper = require('containers/InterestPopper');
const GenericError = require('components/GenericError');
const LoadingScreen = require('components/LoadingScreen');
const MediaViewer = require('components/MediaViewer');
const { default: Classes } = require('./styles.scss');
const Fonts = require('styles/fonts.json');
const _capitalize = require('lodash/capitalize');

const { getSizedImageUrl, getOriginalImageUrl } = require('utils/image');
const { analyticsTemplates } = require('utils/analytics');
const { gotoGroupLink } = require('utils/groups');

const {
    USER_ROLE_IDS,
    DEFAULT_PROFILE_IMG
} = require('utils/constants');

const {
    filterOutKeys,
    filterInKeys,
    makeSimilarityText,
    formatSimilarityText: mainFormatSimilarityText
} = require('utils/makeUsersSimilarityText');

const { makePassionsText } = require('utils/makePassionsText');
const PassionItem = require('components/PassionInterestItem');
const InterestChip = require('components/InterestChip');
const { default: Tooltip } = require('@mui/material/Tooltip');
const { makeRandomInterestsText } = require('utils/makeRandomInterestsText');
const { processProfileImageUploadFromEvent } = require('utils/imageUploadPresets');

const { default: Backdrop } = require('@mui/material/Backdrop');

const internals = {};

const MB_IN_BYTES = 1000000;

class DetailPage extends React.PureComponent {

    // TODO make a selector for the userDetails that only includes
    // profile fields that are public e.g. remove birthdate

    static propTypes = {
        saveProfilePicture: T.func,
        currentUser: T.object,
        onClickChat: T.func,
        onClickConnect: T.func,
        onRequestDisconnect: T.func,
        onAcceptPeer: T.func,
        onEnableUser: T.func,
        interestsLoading: T.bool,
        badges: T.arrayOf(T.shape({
            id: T.number,
            name: T.string,
            svg: T.string,
            icon: T.any,
            label: T.string,
            userPermissions: T.string
        })),
        targetUserRole: T.shape({
            id: T.number,
            name: T.string,
            label: T.string,
            interactions: T.array,
            permissions: T.object
        }),
        userDetails: T.shape({
            user: T.shape({
                id: T.any.isRequired,
                picFile: T.object,
                picPreviewURL: T.string,
                croppedPicture: T.string,
                firstName: T.string,
                lastName: T.string,
                profileEmail: T.string,
                birthdate: T.date,
                age: T.number,
                major: T.string,
                incomingClass: T.string,
                graduatingClass: T.string,
                career: T.string,
                profession: T.string,
                interests: T.array,
                bio: T.string,
                lastActive: T.string,
                studentBio: T.string,
                studentName: T.string,
                veteran: T.bool,
                parent: T.bool,
                onlineStudent: T.bool,
                openToSocial: T.bool,
                fullTime: T.bool,
                gender: T.string,
                type: T.string,
                permissions: T.string,
                enabled: T.bool,
                hometown: T.shape({
                    name: T.string
                }),

                // These are specific to staff
                department: T.string,
                workRemote: T.bool,
                office: T.string,
                yearHired: T.string,
                title: T.string,
                role: T.shape({
                    id: T.number
                })
            }),
            hometown: T.object,
            similarities: T.object,
            housing: T.object,
            school: T.string,
            interests: T.arrayOf(T.string),
            passionInterests: T.arrayOf(T.string),
            classes: T.arrayOf(T.shape({
                id: T.any,
                name: T.string,
                emojiSymbol: T.string,
                type: T.string
            })),
            peers: T.arrayOf(T.shape({
                id: T.any.isRequired,
                firstName: T.string,
                lastName: T.string,
                croppedPicture: T.string
            })),
            peerStatus: T.oneOf(['accepted', 'declined', 'waiting', 'pending', 'declinedByMe', 'declinedByThem']), // or undefined
            chatStatus: T.oneOf(['accepted', 'declined', 'waiting', 'pending', 'declinedByMe', 'declinedByThem']), // or undefined
            transfer: T.shape({
                id: T.any,
                name: T.any,
                classId: T.any
            }),
            isMe: T.bool
        }).isRequired,
        rolePermissions: T.shape({
            id: T.number,
            roleId: T.number,
            schoolId: T.number,
            homeText: T.string,
            canViewMajor: T.bool,
            canViewHomeTown: T.bool,
            canViewCareerAspiration: T.bool,
            canViewProfession: T.bool,
            canViewDepartment: T.bool,
            canViewBadge: T.bool,
            canViewTitle: T.bool,
            canViewIncomingClass: T.bool,
            canViewGraduatingClass: T.bool,
            canViewBio: T.bool,
            canViewLiveOnCampus: T.bool,
            canViewTransfer: T.bool,
            canViewVeteran: T.bool,
            canViewOnline: T.bool,
            canViewParent: T.bool,
            canViewOpenSocial: T.bool,
            canViewTimeStatus: T.bool,
            canViewStudentName: T.bool,
            canViewStudentBio: T.bool,
            canNotify: T.bool,
            canBatchNotify: T.bool,
            canPreapprove: T.bool,
            canDisable: T.bool,
            canCreateGroups: T.bool,
            canEditGroups: T.bool,
            canManageGroups: T.bool,
            canViewWorkRemote: T.bool,
            canViewYearHired: T.bool,
            canViewOffice: T.bool,
            canViewIntroExtro: T.bool
        }),
        rolesInteractions: T.arrayOf(T.shape({
            id: T.number,
            name: T.string,
            label: T.string,
            schoolId: T.number,
            canViewProfile: T.bool,
            canViewInGroup: T.bool,
            canChat: T.bool,
            canChatWithoutConnection: T.bool,
            canSeeConnections: T.bool,
            canSeeUsersGroups: T.bool,
            canSeeSurveyFields: T.bool,
            canSeeExtendedProfile: T.bool,
            allowAutoConnect: T.bool
        })),
        role: T.shape({
            id: T.number,
            name: T.string,
            label: T.string
        }),
        currentUserClasses: T.array,
        currentUserInterests: T.array,
        categories: T.array,
        goBack: T.func,
        push: T.func,
        showNotification: T.func,
        isCompany: T.bool,
        isCommunity: T.bool,
        isSchoolOnline: T.bool,
        discoverNavigation: T.shape({
            currentResultIndex: T.number,
            fromDiscover: T.bool
        }),
        discoveryResults: T.array,
        onNavigateToProfile: T.func,
        hasMoreDiscoverResults: T.bool,
        loadingNextPage: T.bool,
        groupNavigation: T.shape({
            currentResultIndex: T.number,
            fromGroup: T.bool,
            groupId: T.number
        }),
        groupMembers: T.array,
        onNavigateToGroupProfile: T.func,
        debugGroupSorting: T.bool,
        urlContext: T.shape({
            fromDiscover: T.bool,
            fromGroup: T.bool,
            groupId: T.number,
            index: T.number
        })
    }

    constructor(props) {

        super(props);

        this.userInterestsVal = null;

        this.setUserInterestsRef = (element) => {

            this.userInterestsVal = element;
        };

        this.updateUserInterestsRef = () => {

            // Focus the text input using the raw DOM API
            if (this.userInterestsVal !== null) {
                const children = this.userInterestsVal.children;
                if (children.length) {
                    Each(children, (child) => {

                        child.removeAttribute('tabindex');
                    });
                }
            }
        };

        this.state = {
            wide: null,
            loading: true,
            similaritiesLoading: true,
            userFetchError: false,
            notifyUserOpen: false,
            changeRoleOpen: false,
            groupManagementType: false,
            selectedInterest: null,
            interestAnchorRef: null,
            interestPopperOpen: false,
            shuffledPeers: [],
            alertMessage: '',
            alertTitle: '',
            similarityText: '',
            notificationText: '',
            passionsText: '',
            connectBtnDisabled: false,
            mediaViewerOpen: false,
            mediaViewerImageUrl: null,
            cropping: null,
            cropPosition: { x: .5, y: .5 },
            cropRotation: 0,
            cropScale: 1,
            originalPicture: props.userDetails?.user?.croppedPicture || null,
            alertOpen: false
        };
        // Add a mobile breakpoint ('media query listener') for use with inline styles
        this.mql = window.matchMedia('screen and (min-width: 600px)');

        this.chat = this._chat.bind(this);
        this.connect = this._connect.bind(this);
        this.handleMediaQuery = this._handleMediaQuery.bind(this);
        this.classIsTransfer = this._classIsTransfer.bind(this);
        this.disconnectWithUser = this._disconnectWithUser.bind(this);
        this.setUserEnabled = this._setUserEnabled.bind(this);
        this.openNotifyUser = this._openNotifyUser.bind(this);
        this.closeNotifyUser = this._closeNotifyUser.bind(this);
        this.openChangeRole = this._openChangeRole.bind(this);
        this.closeChangeRole = this._closeChangeRole.bind(this);
        this.handleInterestChipClick = this._handleInterestChipClick.bind(this);
        this.handleInterestPopperClose = this._handleInterestPopperClose.bind(this);
        this.shufflePeers = this._shufflePeers.bind(this);
        this.ignorePeer = this._ignorePeer.bind(this);
        this.acceptPeer = this._acceptPeer.bind(this);
        this.createFullSimilarityText = this._createFullSimilarityText.bind(this);
        this.createPassionsText = this._createPassionsText.bind(this);
        //change pics
        this.uploadPhoto = this._uploadPhoto.bind(this);
        this.choosePic = this._choosePic.bind(this);
        this.setPicFile = this._setPicFile.bind(this);
        this.startCropping = this._startCropping.bind(this);
        this.closeCropping = this._closeCropping.bind(this);
        this.doneCropping = this._doneCropping.bind(this);
        this.hasError = this._hasError.bind(this);
        this.validate = this._validate.bind(this);
        this.preparePicPreview = this._preparePicPreview.bind(this);
        this.editPhoto = this._editPhoto.bind(this);
        this.menuButtonRef = createRef();
        this.capturePhoto = this._capturePhoto.bind(this);
    }

    UNSAFE_componentWillMount() {

        this.handleMediaQuery(this.mql);
        this.mql.addListener(this.handleMediaQuery);
    }


    getRandomInterestsText = (user) => {

        /* const randomInterestsText = 'Random interests placeholder';*/

        // const interestsText = makeFirstInterestsText({
        //     passions: this.props.result.passionInterests,
        //     interests: this.props.result.interests,
        //     categories: this.props.categories,
        //     userName: this.props.result.firstName,
        //     isMe: false
        // });

        const categories = this.props.categories;

        const hasData = categories
            && user?.interests
            && user?.firstName;

        if (!hasData) {
            return '';
        }

        return makeRandomInterestsText({
            interests: { interests: user.interests },
            categories,
            userName: user.firstName,
            isMe: false
        });
    }

    _initPage() {

        const {
            rolesInteractions,
            targetUserRole,
            userDetails
        } = this.props;

        // Check if current user role has permission to see other role but not for himself
        const actingRoleInteraction = rolesInteractions.find((roleInteractionItem) => {

            return roleInteractionItem.id === targetUserRole.id;
        });

        const {
            canViewProfile
        } = actingRoleInteraction;

        if (!userDetails.isMe && !canViewProfile) {
            return this.props.push(`/app/not-found`);
        }

        this.updateUserInterestsRef();

        const { peers } = userDetails;

        if (peers.length) {
            const shuffledPeers = this.shufflePeers(peers);
            this.setState({ shuffledPeers, loading: false, userFetchError: false });
        }
        else {
            this.setState({ loading: false, userFetchError: false });
        }
    }

    componentDidMount() {

        // Load the user

        if (this.props.userDetails) {
            this._initPage();
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        if (this.props.userDetails && this.state.loading) {
            this._initPage();
        }

        if (this.state.similaritiesLoading && this.props.userDetails?.similarities || !IsEqual(prevProps?.userDetails?.similarities, this.props.userDetails?.similarities)) {
            this.createFullSimilarityText();
            this.setState({
                similaritiesLoading: false,
                originalPicture: this.props.userDetails?.user?.croppedPicture || null
            });
        }

        if (!this.state.passionsText && this.props.userDetails?.passionInterests?.length) {
            this.createPassionsText();
        }
    }

    dynamicConfirmFunction = () => { };
    dynamicCancelFunction = () => { };

    getPicFile = () => {

        return this.state.picFile;
    }

    maybeHideErrorIfShown = (field, show) => {

        return () => {

            show = (typeof show === 'undefined') ? this.hasError(field) : show;

            if (!show) {
                return this.setState({ [`${field}ErrorShow`]: show });
            }
        };
    }

    setDynamicConfirmFunction(newFunc) {

        this.dynamicConfirmFunction = newFunc;
    }

    setDynamicCancelFunction(newFunc) {

        this.dynamicCancelFunction = newFunc;
    }

    openMediaViewer = (imageUrl) => {

        this.setState({ mediaViewerOpen: true, mediaViewerImageUrl: imageUrl });
    }

    closeMediaViewer = () => {

        this.setState({ mediaViewerOpen: false, mediaViewerImageUrl: null });
    }

    openSimpleDialog = () => {

        this.setState({ alertOpen: true });
    }

    closeSimpleDialog = () => {

        this.setState({ alertOpen: false });
    }

    componentWillUnmount() {

        this.mql.removeListener(this.handleMediaQuery);
    }

    _handleMediaQuery(mql) {

        this.setState({ wide: !!mql.matches });
    }

    _handleInterestChipClick(event, interest) {

        this.setState({
            interestAnchorRef: event.currentTarget,
            selectedInterest: interest,
            interestPopperOpen: true
        });
    }
    _handleInterestPopperClose(event) {

        this.setState({
            interestAnchorRef: null,
            selectedInterest: null,
            interestPopperOpen: false
        });
    }

    _disconnectWithUser() {

        const { user } = this.props.userDetails;

        analyticsTemplates.buttons('begin disconnect from user', 'profile: begin disconnect');

        this.setState({
            alertMessage: `Are you sure you want to disconnect from ${user.firstName}?`,
            alertTitle: `Disconnect from User`
        });
        this.setDynamicConfirmFunction(() => {

            analyticsTemplates.buttons('confirm disconnect from user', 'profile: confirm disconnect');
            this.props.onRequestDisconnect(user);
        });
        this.setDynamicCancelFunction(() => {

            analyticsTemplates.buttons('cancel disconnect from user', 'profile: cancel disconnect');
        });

        this.openSimpleDialog();
    }

    _ignorePeer() {

        const { user } = this.props.userDetails;

        analyticsTemplates.buttons('begin ignore request from user', 'profile: begin ignore');

        this.setState({
            alertMessage: `Are you sure you want to ignore the request from ${user.firstName}?`,
            alertTitle: `Ignore User request`
        });
        this.setDynamicConfirmFunction(() => {

            analyticsTemplates.buttons('confirm ignore request from user', 'profile: confirm ignore');
            this.props.onRequestDisconnect(user);
        });
        this.setDynamicCancelFunction(() => {

            analyticsTemplates.buttons('cancel ignore request from user', 'profile: cancel ignore');
        });

        this.openSimpleDialog();
    }

    _acceptPeer() {

        const { user } = this.props.userDetails;

        this.props.onAcceptPeer({
            id: user.id,
            firstName: user.firstName
        });
    }

    _setUserEnabled() {

        const { user } = this.props.userDetails;

        const toEnable = !user.enabled;
        const toEnableLanguage = toEnable ? 'enable' : 'disable';

        this.setState({
            alertMessage: `Are you sure you want to ${toEnableLanguage} user ${user.firstName}?`,
            alertTitle: `${toEnableLanguage.charAt(0).toUpperCase() + toEnableLanguage.slice(1)} User`
        });
        this.setDynamicConfirmFunction(() => {

            if (toEnable) {
                analyticsTemplates.buttons('enable user', 'profile: enable user');
            }
            else {
                analyticsTemplates.buttons('disable user', 'profile: disable user');
            }

            this.props.onEnableUser(user, toEnable);
        });
        this.setDynamicCancelFunction(() => {

        });

        this.openSimpleDialog();
    }

    _chat() {

        const { userDetails, onClickChat, push } = this.props;

        if (userDetails.peerStatus === 'accepted' ||
            userDetails.chatStatus === 'accepted') {

            return push(`/app/messaging/u:${userDetails.user.id}`);
        }

        return onClickChat(userDetails.user.id);
    }

    async _connect(isAutoConnect) {

        let { notificationText } = this.state;

        if (Array.isArray(notificationText)) {
            notificationText = notificationText[0];
        }

        this.setState({ connectBtnDisabled: true });

        await this.props.onClickConnect(
            this.props.userDetails.user.id,
            null,
            isAutoConnect,
            notificationText
        );

        if (isAutoConnect) {
            this.props.showNotification(`You are now connected to ${this.props.userDetails.user.firstName}`);
            this.setState({ connectBtnDisabled: false });
        }
    }

    _classIsTransfer(class_) {

        const { transfer } = this.props.userDetails;
        return transfer && (transfer.classId === class_.id);
    }

    _openNotifyUser() {

        analyticsTemplates.buttons('open notify modal', 'profile: open notify modal');
        this.setState({ notifyUserOpen: true });
    }

    _closeNotifyUser() {

        this.setState({ notifyUserOpen: false });
    }

    _openChangeRole() {

        analyticsTemplates.buttons('open change role modal', 'profile: open change role modal');
        this.setState({ changeRoleOpen: true });
    }

    _closeChangeRole() {

        this.setState({ changeRoleOpen: false });
    }

    openGroupManagement = () => {

        this.setState({
            groupManagementType: 'superUser',
            groupManagementOpen: true
        });
    }

    openManageMyGroupsDialog = () => {

        analyticsTemplates.buttons('manage groups', 'profile: manage groups');
        this.setState({
            groupManagementType: 'ownUser',
            groupManagementOpen: true
        });
    }

    closeManageGroupsDialog = () => {

        this.setState({ groupManagementOpen: false });
    }

    _shufflePeers(peers) {

        let i = peers.length;
        while (i--) {
            const ri = Math.floor(Math.random() * i);
            [peers[i], peers[ri]] = [peers[ri], peers[i]];
        }

        return peers;
    }

    _uploadPhoto(ev) {

        ev.preventDefault();
        document.getElementById('upload-profile-photo').click();
    }

    _editPhoto() {

        const {
            originalPicture
        } = this.state;
        const picFile = this.getPicFile();

        if (picFile) {
            this.startCropping(picFile);
        }
        else if (originalPicture) {
            const http = context.http.nearpeer;

            fetchOriginalProfilePhotoFile({
                http,
                originalPicture
            }).then(this.setPicFile);
        }
    }

    async _capturePhoto() {

        const { CameraButton } = internals;

        try {
            await captureProfilePhoto({
                cameraButtonStyle: CameraButton.componentStyle.rules.join(''),
                onPhoto: this.setPicFile
            });
        }
        catch (err) {
            console.error('Error accessing webcam:', err);
            this.props.showNotification(getProfilePhotoCaptureErrorMessage());
        }
    }

    async _choosePic(e) {

        let file = e.target.files[0];

        if (file === null) {
            return;
        }

        const { file: processedFile, error } = await processProfileImageUploadFromEvent(e, {
            heicErrorMode: 'use-original',
            onStart: () => this.setState({ convertingProfilePic: true }),
            onComplete: () => this.setState({ convertingProfilePic: false })
        });

        file = processedFile;

        if (error) {
            console.log('Image processing err', error);
        }

        this.setPicFile(file);
        e.target.value = null; // Reset so we can select the same image and still trigger an onChange
    }

    _setPicFile(picFile) {

        this.setState({ picFile }, () => {

            this.maybeHideErrorIfShown('picFile')();
            if (this.validate('picFile') !== null) {
                return this.preparePicPreview(null);
            }

            return this.startCropping(picFile);
        });
    }

    _startCropping(picFile) {

        return this.setState({ cropping: picFile });
    }

    async _doneCropping({ canvas, position, rotation, scale }) {

        this.setState({
            cropping: null,
            cropPosition: position,
            cropRotation: rotation,
            cropScale: scale
        });

        this.preparePicPreview(canvas);

        if (typeof this.props.saveProfilePicture === 'function') {
            this.setState({ uploadingProfilePic: true });
            const res = await this.props.saveProfilePicture({
                picture: this.getPicFile(),
                cropPosition: position,
                cropRotation: rotation,
                cropScale: scale
            });

            this.setState({ uploadingProfilePic: false });

            if (!res) {
                this.setState({ picPreviewURL: '' });
            }
        }
    }

    _closeCropping() {

        this.setState({
            cropping: null,
            cropPosition: { x: .5, y: .5 },
            cropRotation: 0,
            cropScale: 1,
            picFile: null
        });
    }

    _hasError(field) {

        if (this.validate(field) !== null) {
            this.setState({ pageHasErrors: true });
            return true;
        }

        return false;
    }

    _validate(field) {

        const value = field === 'picFile' ? this.getPicFile() : this.state[field];

        switch (field) {
            case 'picFile':

                const profilePhotoError = validateProfilePhotoFile(value, {
                    mbInBytes: MB_IN_BYTES
                });

                if (profilePhotoError) {
                    return profilePhotoError;
                }

                if (!value && !this.state.croppedPicture && !this.state.picPreviewURL) {
                    return 'Profile pic is required';
                }

                break;
        }

        return null;
    }

    _createFullSimilarityText() {

        let baseSimilarityText;
        let studentSimilarityText;

        const studentSimilarityTypes = [
            'majors',
            'transfer',
            'online'
        ];

        const {
            currentUserInterests,
            currentUser,
            userDetails
        } = this.props;

        const {
            user,
            isMe,
            similarities
        } = userDetails;

        const { role: viewedProfileRole } = user || {};

        const isParent = USER_ROLE_IDS.PARENT.includes(viewedProfileRole.id);

        if (!isMe) {
            let baseSimilarities = '';
            let classSimilarities = '';

            if (isParent) {
                ({ baseSimilarities, classSimilarities } = makeSimilarityText({
                    similarities: filterOutKeys(similarities, studentSimilarityTypes)
                }));
            }
            else {
                ({ baseSimilarities, classSimilarities } = makeSimilarityText({
                    similarities
                }));
            }

            if (baseSimilarities || classSimilarities) {
                if (isParent) {

                    baseSimilarityText = `${baseSimilarities ?? ''} ${classSimilarities ?? ''}`;

                    const { baseSimilarities: studentBaseSimilarities } = makeSimilarityText({
                        similarities: filterInKeys(similarities, studentSimilarityTypes),
                        areStartTxt: ' are'
                    });

                    studentSimilarityText = studentBaseSimilarities;
                }
                else {
                    baseSimilarityText = `${baseSimilarities ?? ''} ${classSimilarities ?? ''}`;
                }
            }
            else {
                const userInView = {
                    firstName: this.props.userDetails.user.firstName,
                    interests: this.props.userDetails.interests,
                    id: this.props.userDetails.user.id
                };

                const curUser = {
                    firstName: currentUser.firstName,
                    interests: currentUserInterests,
                    id: currentUser.id
                };

                return this.setState({
                    similarityText: this.getRandomInterestsText(userInView),
                    notificationText: this.getRandomInterestsText(curUser)
                });
            }
        }

        const similarityText = this.formatSimilarityText(
            baseSimilarityText,
            studentSimilarityText,
            user.firstName,
            isParent
        );

        return this.setState({
            similarityText,
            notificationText: similarityText
        });
    }

    _preparePicPreview(canvas) {

        return this.setState({ picPreviewURL: canvas && canvas.toDataURL() });
    }

    _createPassionsText() {

        let basePassionText;

        const {
            user,
            isMe,
            passionInterests
        } = this.props.userDetails;

        const {
            categories
        } = this.props;

        if (passionInterests) {
            basePassionText = makePassionsText({
                passions: { passions: passionInterests },
                categories,
                userName: user.firstName,
                isMe
            });
        }

        return this.setState({
            passionsText: basePassionText
        });
    }

    renderPassionsHolder() {

        const {
            passionInterests
        } = this.props.userDetails;

        const {
            BigDivider,
            PassionsHolder
        } = internals;

        const { categories } = this.props;
        const { passionsText } = this.state;
        const passions = passionInterests;

        const usedCategoriesIds = Array.from(new Set(passions.map((interest) => interest.categoryId)));
        const usedCategories = categories.filter((category) => usedCategoriesIds.includes(category.id));
        const sortedCategories = SortBy(usedCategories, ['name']);

        return <React.Fragment>
            <BigDivider />
            <PassionsHolder>
                {sortedCategories.map((category) => {

                    const filteredInterests = passions.filter((interest) => {

                        return interest.categoryId === category.id;
                    }).sort(this.sortInterests);

                    return filteredInterests.map((interest) => {

                        const svg = (interest && interest.svg) ? interest.svg : ((category && category.svg) ? category.svg : null);

                        if (svg) {
                            return <PassionItem key={interest.id} interest={interest} svg={svg} />;
                        }
                    });
                })}
            </PassionsHolder>
            <div style={{ paddingTop: 10, fontSize: 16 }}>
                <span style={{ width: '100%' }}>{passionsText}</span>
            </div>
        </React.Fragment>;
    }

    formatSimilarityText(baseSimilarityText, studentSimilarityText, peerName, isParent) {

        let fullSimilarityText = '';
        if (baseSimilarityText || studentSimilarityText) {
            if (baseSimilarityText) {
                fullSimilarityText = `${baseSimilarityText} `;
            }

            if (studentSimilarityText) {
                if (isParent) {
                    fullSimilarityText = fullSimilarityText + `Your students${studentSimilarityText}`;
                }
                else {
                    fullSimilarityText = fullSimilarityText + `You and ${peerName}'s student ${studentSimilarityText}`;
                }
            }
        }

        return mainFormatSimilarityText(fullSimilarityText);
    }

    sortInterests(a, b) {

        const aSpecial = a && a.special;
        const bSpecial = b && b.special;

        return (Number(bSpecial) - Number(aSpecial)) || (a.categoryName.localeCompare(b.categoryName)) || a.name.localeCompare(b.name);
    }

    sortPeers(peers) {

        return peers.sort((peer1, peer2) => {

            return (`${peer1.firstName.toLowerCase()} ${peer1.lastName.toLowerCase()}` < `${peer2.firstName.toLowerCase()} ${peer2.lastName.toLowerCase()}`) ? -1 : 1;
        });
    }

    render() {

        const {
            userDetails,
            goBack,
            badges,
            currentUser,
            currentUserClasses,
            currentUserInterests,
            rolePermissions,
            rolesInteractions,
            targetUserRole,
            showNotification,
            interestsLoading,
            isCompany,
            isCommunity,
            isSchoolOnline,
            categories,
            push,
            discoverNavigation,
            discoveryResults,
            onNavigateToProfile,
            hasMoreDiscoverResults,
            loadingNextPage,
            groupNavigation,
            groupMembers,
            onNavigateToGroupProfile,
            debugGroupSorting,
            urlContext
        } = this.props;

        const currentUserInterestsIds = currentUserInterests?.map((interest) => interest.id);

        // Handle case where data is still in flight
        if (this.state.loading || interestsLoading) {
            return <LoadingScreen variant='content' />;
        }

        // Failed to load the requested user
        if (this.state.userFetchError || !userDetails) {
            return <GenericError />;
        }

        const {
            Wrapper,
            BigDivider,
            styles,
            getPronouns,
            Header,
            HeaderTitle,
            UserBadgeGroup,
            UserBadge,
            SchoolLine,
            UserBadgeLabel,
            TopRowExtras,
            ProfileDetailLine,
            ProfileDetailParagraph,
            ProfileDetailSpan,
            HeaderLeftSide,
            HeaderRightSide,
            EditIconButton,
            FlexRow,
            SpinnerContainer,
            InterestHelperText,
            StyledImageRequestBtn,
            ConnectButton,
            StyledBackdrop,
            InterestChip,
            SchoolInfo
        } = internals;

        const {
            user,
            school,
            interests,
            passionInterests,
            classes,
            peers,
            peerStatus,
            isMe,
            transfer,
            housing
        } = userDetails;

        const sortedGroups = SortBy(classes, ['name']);

        const actingRoleInteraction = rolesInteractions.find((item) => {

            return item.id === targetUserRole.id;
        });

        const {
            canChat: canChatPermission,
            allowAutoConnect: allowAutoConnectPermission,
            canSeeUsersGroups: canSeeUsersGroupsPermission,
            canSeeConnections: canSeeConnectionsPermission
        } = actingRoleInteraction;

        const userBadge = badges && badges.find(({ name }) => name === user.type);

        const {
            gender = '',
            role: viewedProfileRole,
            studentName,
            studentBio
        } = user || {};

        const pronouns = getPronouns(gender);
        const capitalizedUserType = user.type && _capitalize(user.type);
        const isEnabled = user.enabled;

        const usedCategoriesIds = Array.from(new Set(
            interests.map((interest) => interest.categoryId)
        ));

        const usedCategories = categories.filter((category) => usedCategoriesIds.includes(category.id));
        const sortedCategories = SortBy(usedCategories, ['name']);

        const canChat = !isMe && isEnabled && canChatPermission && peerStatus === 'accepted';

        const canRequestPeer = !isMe && isEnabled && (!peerStatus || peerStatus === 'declinedByMe');
        const disconnectedPeer = !isMe && isEnabled && peerStatus === 'declinedByMe';
        const canDisconnect = !isMe && isEnabled && !!peerStatus && peerStatus !== 'declinedByMe' && peerStatus !== 'declinedByThem';

        const waitingForResponse = !isMe && isEnabled && (peerStatus === 'waiting' || peerStatus === 'declinedByThem');
        const pendingMyResponse = !isMe && isEnabled && peerStatus === 'pending';

        const canSeeUsersGroups = !isMe ? canSeeUsersGroupsPermission : true;
        const canSeeUsersConnections = !isMe ? canSeeConnectionsPermission : true;
        // const canSeeAllGroups = !isMe ? actingRoleInteraction.canSeeAllGroups : true;

        const settingsMenuOptions = [];

        const isParent = USER_ROLE_IDS.PARENT.includes(viewedProfileRole.id);
        const isStudent = USER_ROLE_IDS.STUDENT.includes(viewedProfileRole.id);
        const isStaffOrSuper = USER_ROLE_IDS.STAFF.includes(viewedProfileRole.id) || USER_ROLE_IDS.SUPERUSER.includes(viewedProfileRole.id);
        const fullName = `${user.firstName} ${user.lastName}`;

        if (canDisconnect) {
            settingsMenuOptions.push({
                name: `Disconnect from ${user.firstName}`,
                action: this.disconnectWithUser
            });
        }

        if (disconnectedPeer) {
            settingsMenuOptions.push({
                name: `Reconnect with ${user.firstName}`,
                action: () => {

                    this.connect(allowAutoConnectPermission);
                }
            });
        }

        if (rolePermissions) {
            if (rolePermissions.canManageGroups) {
                settingsMenuOptions.push({
                    name: isMe ? 'Manage My Groups' : `Manage ${userDetails.user.firstName}'s Groups`,
                    action: isMe ? this.openManageMyGroupsDialog : this.openGroupManagement
                });
            }

            if (rolePermissions.canDisable) {
                const toEnableLanguage = isEnabled ? 'Disable' : 'Enable';

                settingsMenuOptions.push({
                    name: `${toEnableLanguage} user ${userDetails.user.firstName}`,
                    action: this.setUserEnabled
                });
            }

            if (rolePermissions.canNotify) {
                settingsMenuOptions.push({
                    name: `Notify ${userDetails.user.firstName}`,
                    action: this.openNotifyUser
                });
            }
        }

        const currentUserIsSuperuser = !!currentUser && USER_ROLE_IDS.SUPERUSER.includes(currentUser.roleId);

        if (currentUserIsSuperuser && !isMe && isEnabled) {
            settingsMenuOptions.push({
                name: `Change ${userDetails.user.firstName}'s Role`,
                action: this.openChangeRole
            });
        }

        const { connectBtnDisabled } = this.state;

        const titlePrefix = isMe ? 'Your' : `${user.firstName}'s`;

        let onlineClassPrefix;
        let campusPrefix;
        let studentInfoIsPrefix;

        if (isParent) {
            onlineClassPrefix = isMe ? 'Your student takes' : `${user.firstName}'s student takes`;
            campusPrefix = isMe ? 'Your student lives' : `${user.firstName}'s student lives`;
            studentInfoIsPrefix = isMe ? 'Your student is' : `${user.firstName}'s student is`;
        }
        else {
            onlineClassPrefix = isMe ? 'You take' : `${user.firstName} takes`;
            campusPrefix = isMe ? 'You live' : `${user.firstName} lives`;
            studentInfoIsPrefix = isMe ? 'You\'re' : `${user.firstName} is`;
        }

        const infoIsPrefix = isMe ? 'You\'re' : `${user.firstName} is`;

        const showInterestHelperText = !isMe && !!(interests.find(({ id }) => !currentUserInterestsIds.includes(id)));

        const shouldRenderConnectionField = !isMe && (
            waitingForResponse ||
            pendingMyResponse ||
            disconnectedPeer ||
            canRequestPeer ||
            canChat
        );

        // All users will have user.croppedPicture set to something when viewing DetailPage
        const hasNonDefaultProfilePic = user.croppedPicture !== (rolePermissions?.defaultPhoto || DEFAULT_PROFILE_IMG);

        const isFromDiscover = urlContext?.fromDiscover || false;
        const isFromGroup = urlContext?.fromGroup || false;

        const currentIndex = discoverNavigation.currentResultIndex;
        const hasResults = discoveryResults && discoveryResults.length > 0;
        const isValidIndex = typeof currentIndex === 'number';

        const canNavigatePrev = isFromDiscover && hasResults && isValidIndex && currentIndex > 0;
        const isAtEnd = isValidIndex && currentIndex === discoveryResults.length - 1;
        const canNavigateNext = isFromDiscover && hasResults && isValidIndex &&
            (currentIndex < discoveryResults.length - 1 || (isAtEnd && hasMoreDiscoverResults && !loadingNextPage));

        const groupCurrentIndex = groupNavigation.currentResultIndex;
        const hasGroupResults = groupMembers && groupMembers.length > 0;
        const isGroupValidIndex = typeof groupCurrentIndex === 'number';

        const canGroupNavigatePrev = isFromGroup && hasGroupResults && isGroupValidIndex && groupCurrentIndex > 0;
        const canGroupNavigateNext = isFromGroup && hasGroupResults && isGroupValidIndex && groupCurrentIndex < groupMembers.length - 1;

        const handleNavigatePrev = () => {

            if (isFromDiscover && canNavigatePrev && onNavigateToProfile) {
                const prevUser = discoveryResults[currentIndex - 1];
                onNavigateToProfile(prevUser.id, currentIndex - 1);
            }
            else if (isFromGroup && canGroupNavigatePrev && onNavigateToGroupProfile) {
                const prevUser = groupMembers[groupCurrentIndex - 1];
                onNavigateToGroupProfile(prevUser.id, groupCurrentIndex - 1);
            }
        };

        const handleNavigateNext = () => {

            if (isFromDiscover && canNavigateNext && onNavigateToProfile) {
                const nextIndex = currentIndex + 1;
                const needsAutoLoad = isAtEnd && hasMoreDiscoverResults && !loadingNextPage;

                if (needsAutoLoad) {
                    onNavigateToProfile(null, nextIndex, true);
                }
                else {
                    const nextUser = discoveryResults[nextIndex];
                    onNavigateToProfile(nextUser.id, nextIndex);
                }
            }
            else if (isFromGroup && canGroupNavigateNext && onNavigateToGroupProfile) {
                const nextUser = groupMembers[groupCurrentIndex + 1];
                onNavigateToGroupProfile(nextUser.id, groupCurrentIndex + 1);
            }
        };

        const handleBackClick = () => {

            goBack(-3);
        };

        return (
            <Wrapper>
                <SimpleDialog
                    isOpen={this.state.alertOpen}
                    onRequestClose={this.closeSimpleDialog}
                    title={this.state.alertTitle}
                    content={this.state.alertMessage}
                    buttons={<React.Fragment>
                        <FlatButton
                            onClick={() => {
                                this.closeSimpleDialog();
                                this.dynamicCancelFunction();
                            }}
                            color='secondary'
                            variant='contained'
                            data-focus-outline='radius:40'
                            style={{ marginRight: '10px' }}
                        >
                            No
                        </FlatButton>
                        <FlatButton
                            onClick={() => {
                                this.closeSimpleDialog();
                                this.dynamicConfirmFunction();
                            }}
                            variant='contained'
                            data-focus-outline='radius:40'
                        >
                            Yes
                        </FlatButton>
                    </React.Fragment>}
                />
                {!isEnabled && <MessageBanner
                    text='This account has been closed.'
                />}
                {shouldRenderConnectionField && (
                <ScrollPortal top>
                    <Paper elevation={0} className={`${Classes.fixedPeerChat} contentWrapper`}>
                        {(waitingForResponse || pendingMyResponse) && <>
                            {waitingForResponse && <NavigationButtonContainer
                                urlContext={urlContext}
                                discoveryResults={discoveryResults}
                                groupMembers={groupMembers}
                                canNavigatePrev={canNavigatePrev}
                                canNavigateNext={canNavigateNext}
                                canGroupNavigatePrev={canGroupNavigatePrev}
                                canGroupNavigateNext={canGroupNavigateNext}
                                handleNavigatePrev={handleNavigatePrev}
                                handleNavigateNext={handleNavigateNext}
                            >
                                <ConnectButton
                                    disabled
                                    fullWidth
                                >
                                    Waiting for their response
                                </ConnectButton>
                            </NavigationButtonContainer>}
                            {pendingMyResponse && <NavigationButtonContainer
                                urlContext={urlContext}
                                discoveryResults={discoveryResults}
                                groupMembers={groupMembers}
                                canNavigatePrev={canNavigatePrev}
                                canNavigateNext={canNavigateNext}
                                canGroupNavigatePrev={canGroupNavigatePrev}
                                canGroupNavigateNext={canGroupNavigateNext}
                                handleNavigatePrev={handleNavigatePrev}
                                handleNavigateNext={handleNavigateNext}
                            >
                                <div style={{ display: 'flex', width: '100%', flexFlow: 'column', justifyContent: 'center' }}>
                                    <h3 style={{
                                        textAlign: 'center',
                                        marginTop: 23,
                                        fontSize: 17,
                                        marginBottom: 25
                                    }}>
                                        {`${user.firstName} would like to connect with you!`}
                                    </h3>
                                    <Box sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-evenly',
                                        marginBottom: '1rem'
                                    }}>
                                        <StyledImageRequestBtn
                                            variant='outlined'
                                            color='secondary'
                                            onClick={this.ignorePeer}
                                            data-focus-outline='radius:40,padding:-1'
                                        >
                                            Ignore
                                        </StyledImageRequestBtn>
                                        <StyledImageRequestBtn
                                            variant='contained'
                                            color='primary'
                                            onClick={this.acceptPeer}
                                            data-focus-outline='radius:40,padding:-1'
                                        >
                                            Accept
                                        </StyledImageRequestBtn>
                                    </Box>
                                </div>
                            </NavigationButtonContainer>}
                        </>}
                        {disconnectedPeer && <NavigationButtonContainer
                            urlContext={urlContext}
                            discoveryResults={discoveryResults}
                            groupMembers={groupMembers}
                            canNavigatePrev={canNavigatePrev}
                            canNavigateNext={canNavigateNext}
                            canGroupNavigatePrev={canGroupNavigatePrev}
                            canGroupNavigateNext={canGroupNavigateNext}
                            handleNavigatePrev={handleNavigatePrev}
                            handleNavigateNext={handleNavigateNext}
                        >
                            <ConnectButton
                                label='Disconnected'
                                disabled
                                fullWidth
                            >
                                Disconnected
                            </ConnectButton>
                        </NavigationButtonContainer>}
                        {!disconnectedPeer && canRequestPeer && <NavigationButtonContainer
                            urlContext={urlContext}
                            discoveryResults={discoveryResults}
                            groupMembers={groupMembers}
                            canNavigatePrev={canNavigatePrev}
                            canNavigateNext={canNavigateNext}
                            canGroupNavigatePrev={canGroupNavigatePrev}
                            canGroupNavigateNext={canGroupNavigateNext}
                            handleNavigatePrev={handleNavigatePrev}
                            handleNavigateNext={handleNavigateNext}
                        >
                            <ConnectButton
                                disabled={connectBtnDisabled}
                                fullWidth
                                onClick={() => this.connect(allowAutoConnectPermission)}
                                data-focus-outline='radius:40'
                            >
                                {allowAutoConnectPermission ? 'Auto Connect' : 'Connect'}
                            </ConnectButton>
                        </NavigationButtonContainer>}
                        {!disconnectedPeer && canChat && <NavigationButtonContainer
                            urlContext={urlContext}
                            discoveryResults={discoveryResults}
                            groupMembers={groupMembers}
                            canNavigatePrev={canNavigatePrev}
                            canNavigateNext={canNavigateNext}
                            canGroupNavigatePrev={canGroupNavigatePrev}
                            canGroupNavigateNext={canGroupNavigateNext}
                            handleNavigatePrev={handleNavigatePrev}
                            handleNavigateNext={handleNavigateNext}
                        >
                            <ConnectButton
                                fullWidth
                                $isChat
                                onClick={this.chat}
                                data-focus-outline='radius:40'
                            >
                                Chat
                            </ConnectButton>
                        </NavigationButtonContainer>}
                    </Paper>
                </ScrollPortal>
                )}

                <div className={Classes.main}>
                    <TopRowExtras>
                        <Tooltip
                            arrow
                            title='Close'
                            placement='left'
                         className='nearpeer-profile-photo-actions'>
                            <IconButton
                                onClick={handleBackClick}
                                aria-label='previous screen'
                                size='large'
                                data-focus-outline={this.state.wide ? 'radius:30,padding:-2,zIndex:1' : 'radius:30,padding:-8,zIndex:1'}
                            >
                                <Close />
                            </IconButton>
                        </Tooltip>
                        {(settingsMenuOptions.length !== 0) && (<MaterialMenu
                            anchorOrigin={{ horizontal: 'left' }}
                            buttonRef={this.menuButtonRef}
                            iconElement={<SettingsIcon
                                style={{ color: Colors.darkGrey }}
                                onKeyDown={(evt) => {

                                    if (evt.key === 'Enter' || evt.code === 'Space') {
                                        this.menuButtonRef.current?.click();
                                    }
                                }}
                            />}
                            menuOptions={settingsMenuOptions}
                        />)}
                    </TopRowExtras>

                    <Header>
                        <HeaderLeftSide>
                            <ProfilePhotoFrame>
                                {!isMe && <Image
                                    ratio='1/1'
                                    eager
                                    priority={2}
                                    src={getSizedImageUrl(user.croppedPicture, 400)}
                                    alt={`${user.firstName}'s Profile Photo`}
                                    onClick={() => this.openMediaViewer(getOriginalImageUrl(user.croppedPicture))}
                                    style={{ cursor: 'pointer' }}
                                />}
                                {isMe && (
                                    <ProfilePhotoEditor
                                        style={{ backgroundImage: user.croppedPicture }}
                                    >
                                        <Image
                                            ratio='1/1'
                                            eager
                                            priority={2}
                                            placeholderBottomSpace={56}
                                            src={getSizedImageUrl(user.croppedPicture, 400)}
                                            alt={`${user.firstName}'s Profile Photo`}
                                        />
                                        <ProfilePhotoActions
                                            canEditPhoto={!!(this.state.picFile ||
                                                (this.state.originalPicture && hasNonDefaultProfilePic))}
                                            disabled={this.state.uploadingProfilePic || this.state.convertingProfilePic}
                                            onEdit={() => {
                                                this.editPhoto();
                                                FocusIndicator.onBlurHandler();
                                            }}
                                            onUpload={(event) => {
                                                this.uploadPhoto(event);
                                                FocusIndicator.onBlurHandler();
                                            }}
                                            onCapture={() => {
                                                this._capturePhoto();
                                                FocusIndicator.onBlurHandler();
                                            }}
                                        />

                                        <StyledBackdrop open={this.state.submitting || this.state.uploadingProfilePic || this.state.convertingProfilePic}>
                                            <SpinnerContainer>
                                                <LoadingScreen variant='content' />
                                            </SpinnerContainer>
                                        </StyledBackdrop>

                                        <input
                                            id='upload-profile-photo'
                                            type='file'
                                            accept='image/*,.heic'
                                            aria-label='Upload photo'
                                            onChange={this.choosePic}
                                            style={{ visibility: 'hidden', width: '0px', height: '0px' }}
                                            ref={this.picFile}
                                        />
                                    </ProfilePhotoEditor>
                                )}
                            </ProfilePhotoFrame>
                        </HeaderLeftSide>

                        <HeaderRightSide>
                            <div>
                                <HeaderTitle>{fullName}</HeaderTitle>
                                {userBadge &&
                                    <UserBadgeGroup>
                                        {rolePermissions.canViewBadge && <UserBadge extraLarge userType={user.type} userLabel={userBadge.label || capitalizedUserType} />}
                                        <UserBadgeLabel>{rolePermissions.canViewBadge && (userBadge.label || capitalizedUserType)}</UserBadgeLabel>
                                    </UserBadgeGroup>
                                }
                                {!userBadge && <div>{capitalizedUserType}</div>}
                                <BigDivider />
                            </div>
                            <SchoolInfo>
                                {!isMe && <SchoolLine>{school}</SchoolLine>}
                                {isStudent && rolePermissions.canViewMajor && user.major && <ProfileDetailLine>{user.major}</ProfileDetailLine>}
                                {rolePermissions.canViewDepartment && user.department && <ProfileDetailLine>{user.department}</ProfileDetailLine>}
                                {isStudent && rolePermissions.canViewIncomingClass && user.incomingClass && <ProfileDetailLine>{`Incoming ${user.incomingClass}`}</ProfileDetailLine>}
                                {isStudent && rolePermissions.canViewGraduatingClass && user.graduatingClass && <ProfileDetailLine>{`Class of ${user.graduatingClass}`}</ProfileDetailLine>}
                                {rolePermissions.canViewTitle && user.title && <ProfileDetailParagraph>{user.title}</ProfileDetailParagraph>}
                            </SchoolInfo>
                        </HeaderRightSide>

                        <CropAvatarDialog
                            open={!!this.state.cropping}
                            onClose={this.closeCropping}
                            file={this.state.cropping}
                            onDone={this.doneCropping}
                            contentClassName={Classes.cropAvatarDialog}
                        />
                    </Header>

                    <UserAchievements user={user} extraUserInfo={{ peers }} className={Classes.achievementsContainer} />

                    {passionInterests && passionInterests.length > 0 && this.renderPassionsHolder()}

                    {!isMe && this.state.similarityText && this.state.similarityText.length > 0 && <>
                        <BigDivider />
                        <div className={Classes.infoPairContainer}>
                            <span style={{ width: '100%' }} dangerouslySetInnerHTML={{ __html: this.state.similarityText }} />
                        </div>
                    </>}

                    {/* INFO SECTION */}

                    <div className={Classes.infoSection}>
                        <BigDivider />
                        <FlexRow style={{ marginBottom: 22 }}>
                            <div>
                                <h3>{titlePrefix} Info</h3>
                            </div>
                            {isMe ? <Tooltip
                                arrow
                                title='Edit My Profile'
                                placement='top'
                                data-focus-outline='radius:30,padding:-2,zIndex:1'
                            >
                                <EditIconButton
                                    size='large'
                                    component={RouterLink}
                                    to={{
                                        pathname: '/app/profile/edit',
                                        state: {
                                            returnTo: `/app/profile/${user.id}`
                                        }
                                    }}
                                >
                                    <EditIcon />
                                </EditIconButton>
                            </Tooltip> : null}
                        </FlexRow>
                        {rolePermissions.canViewBio && !!user.bio && <div className={Classes.infoPairContainer}>
                            <div className={Classes.oneLinerTitle}>Bio</div>
                            <span>&ldquo;{user.bio}&rdquo;</span>
                        </div>}
                        {!!user.gender && user.gender !== 'decline' && <div className={Classes.infoPairContainer}>
                            <div className={Classes.oneLinerTitle}>Pronouns</div>
                            <span>{pronouns}</span>
                        </div>}
                        {!isParent && rolePermissions.canViewLiveOnCampus && (isCompany || isCommunity || isSchoolOnline) && !!housing?.name && !housing?.onCampus && <div className={Classes.infoPairContainer}>
                            <div className={Classes.oneLinerTitle}>Lives In</div>
                            <div className={Classes.hometownWrapper}><span>{housing.name}</span></div>
                        </div>}
                        {rolePermissions.canViewHomeTown && user.hometown?.name && <div className={Classes.infoPairContainer}>
                            <div className={Classes.oneLinerTitle}>{(isCompany || isCommunity || isSchoolOnline) ? 'Grew Up In' : 'Hometown'}</div>
                            <div className={Classes.hometownWrapper}><span>{user.hometown.name}</span></div>
                        </div>}
                        {rolePermissions.canViewCareerAspiration && user.career && <div className={Classes.infoPairContainer}>
                            <div className={Classes.oneLinerTitle}>Career Aspiration</div>
                            <span>{user.career}</span>
                        </div>}
                        {rolePermissions.canViewProfession && user.profession && <div className={Classes.infoPairContainer}>
                            <div className={Classes.oneLinerTitle}>Profession</div>
                            <span>{user.profession}</span>
                        </div>}
                        {isCompany && rolePermissions.canViewOffice && user.office && <div className={Classes.infoPairContainer}>
                            <div className={Classes.oneLinerTitle}>{'Affiliated Office'}</div>
                            <span>{user.office}</span>
                        </div>}
                        {isCompany && rolePermissions.canViewYearHired && user.yearHired && <div className={Classes.infoPairContainer}>
                            <div className={Classes.oneLinerTitle}>Year Hired</div>
                            <span>{user.yearHired}</span>
                        </div>}
                        {!isParent && !isStaffOrSuper && rolePermissions.canViewIncomingClass && user.incomingClass && <div className={Classes.infoPairContainer}>
                            <div className={Classes.oneLinerTitle}>Incoming Class</div>
                            <span>{user.incomingClass}</span>
                        </div>}
                        {!isParent && !isStaffOrSuper && rolePermissions.canViewGraduatingClass && user.graduatingClass && <div className={Classes.infoPairContainer}>
                            <div className={Classes.oneLinerTitle}>Graduating Class</div>
                            <span>{user.graduatingClass}</span>
                        </div>}
                        {/*{!!(user.lastActive) && <div className={Classes.infoPairContainer}>
                            <span className={Classes.oneLinerTitle}>{'Last Active'}</span>
                            <span>{user.lastActive}</span>
                        </div>}*/}
                        {((isMe && rolePermissions.canEditIntroExtro) || rolePermissions.canViewIntroExtro) && user.introExtroLevel != null && <div className={Classes.infoPairContainer}>
                            <div className={Classes.oneLinerTitle}>Personality Trait</div>
                            <span>{{1: 'Very Introverted', 2: 'Somewhat Introverted', 3: 'Ambivert', 4: 'Somewhat Extroverted', 5: 'Very Extroverted'}[user.introExtroLevel]}</span>
                        </div>}
                        {rolePermissions.canViewVeteran && !!user.veteran && <div className={Classes.infoPairContainer}>
                            <span className={Classes.infoLine}><StarIcon className={Classes.smallIcon} />{infoIsPrefix} a veteran</span>
                        </div>}
                        {!isParent && rolePermissions.canViewParent && !!user.parent && <div className={Classes.infoPairContainer}>
                            <span className={Classes.infoLine}><ChildIcon className={Classes.smallIcon} />{infoIsPrefix} a parent</span>
                        </div>}
                        {rolePermissions.canViewWorkRemote && !!user.workRemote && <div className={Classes.infoPairContainer}>
                            <span className={Classes.infoLine}><HomeWorkIcon className={Classes.smallIcon} />{infoIsPrefix} working remotely</span>
                        </div>}
                        {!isCompany && !isCommunity && !isSchoolOnline && !isParent && !isStaffOrSuper && rolePermissions.canViewLiveOnCampus && !!housing && !!housing.name && housing.onCampus && <div className={Classes.infoPairContainer}>
                            <span className={Classes.infoLine}><LocationCity className={Classes.smallIcon} />{campusPrefix} {` on campus${!!housing.id && !!housing.name && ` at ${housing.name}`}`}</span>
                        </div>}
                        {!isCompany && !isCommunity && !isSchoolOnline && !isParent && !isStaffOrSuper && rolePermissions.canViewLiveOnCampus && !!housing && !!housing.name && !housing.onCampus && <div className={Classes.infoPairContainer}>
                            <span className={Classes.infoLine}><LocationCity className={Classes.smallIcon} />{campusPrefix} {` off-campus${!!housing.name && ` at ${housing.name}`}`}</span>
                        </div>}
                        {!isCompany && !isCommunity && !isParent && !isStaffOrSuper && rolePermissions.canViewTransfer && !!transfer && <div className={Classes.infoPairContainer}>
                            <span className={Classes.infoLine}><RedoIcon className={Classes.smallIcon} />{studentInfoIsPrefix} a transfer student {!!transfer.name && `from ${transfer.name}`}</span>
                        </div>}
                        {!isSchoolOnline && !isParent && rolePermissions.canViewOnline && !!user.onlineStudent && <div className={Classes.infoPairContainer}>
                            <span className={Classes.infoLine}><OnlineIcon className={Classes.smallIcon} />{onlineClassPrefix} online classes</span>
                        </div>}
                        {!isStaffOrSuper && !isParent && rolePermissions.canViewTimeStatus && <div className={Classes.infoPairContainer}>
                            <span className={Classes.infoLine}><TimeLapse className={Classes.smallIcon} />{infoIsPrefix} a {(user.fullTime || user.fullTime === null) ? 'full-time' : 'part-time'} student</span>
                        </div>}
                    </div>

                    {/* INTERESTS SECTION */}

                    {!!interests.length && <div>
                        {this.state.selectedInterest && !isMe &&
                            <InterestPopper
                                interest={this.state.selectedInterest}
                                onClose={this.handleInterestPopperClose}
                                open={this.state.interestPopperOpen}
                                anchorRef={this.state.interestAnchorRef}
                            />
                        }
                        <BigDivider />
                        <div className={Classes.sectionHeaderStyles}>
                            <FlexRow style={{ marginBottom: 22 }}>
                                <div>
                                    <h3>{titlePrefix} Interests</h3>
                                </div>
                                {showInterestHelperText && <InterestHelperText>
                                    Click any Interest below to add it to your own profile.
                                </InterestHelperText>}
                                {isMe ? <Tooltip
                                    arrow
                                    title='Edit My Interests'
                                    placement='top'
                                    data-focus-outline='radius:30,padding:-2,zIndex:1'
                                >
                                    <EditIconButton
                                        size='large'
                                        component={RouterLink}
                                        to={{
                                            pathname: '/app/profile/edit/interests',
                                            state: {
                                                returnTo: `/app/profile/${user.id}`
                                            }
                                        }}
                                    >
                                        <EditIcon />
                                    </EditIconButton>
                                </Tooltip> : null}
                            </FlexRow>
                        </div>

                        <div ref={this.setUserInterestsRef}>
                            {sortedCategories.map((category) => {

                                const filteredInterests = interests.filter((interest) => interest.categoryId === category.id).sort((a, b) => {

                                    const aIsPassion = passionInterests && passionInterests.some((passionInterest) => {

                                        return passionInterest.id === a.id;
                                    });

                                    const bIsPassion = passionInterests && passionInterests.some((passionInterest) => {

                                        return passionInterest.id === b.id;
                                    });

                                    const aSpecial = a && a.special;
                                    const bSpecial = b && b.special;

                                    return (Number(bIsPassion) - Number(aIsPassion)) || (Number(bSpecial) - Number(aSpecial)) || (a.categoryName.localeCompare(b.categoryName)) || a.name.localeCompare(b.name);
                                });

                                return (
                                    <React.Fragment key={category.id}>
                                        <div className={Classes.categoryHolder}>
                                            <h4 style={{ margin: 0 }}
                                                aria-label={`Interests Category ${category.name}`}
                                            >
                                                {category.name}
                                            </h4>
                                        </div>
                                        <div className={Classes.interests}>
                                            {filteredInterests.map((interest) => {

                                                const alreadyHasInterest = currentUserInterestsIds.includes(interest.id);

                                                const isPassion = passionInterests.some((passionInterest) => {

                                                    return passionInterest.id === interest.id;
                                                });
                                                //Only allow to add inteerest on other people pages and on the inbterest that user dont have
                                                return <InterestChip
                                                    isPassion={isPassion}
                                                    handleClick={(!isMe && !alreadyHasInterest) ? (event) => {

                                                        this.handleInterestChipClick(event, interest);
                                                    } : null}
                                                    isCommonInterest={!isMe && alreadyHasInterest}
                                                    className={Classes.interest}
                                                    key={interest.id}
                                                    interest={interest}
                                                    category={category}
                                                    isMe={isMe}
                                                />;
                                            })}
                                        </div>
                                    </React.Fragment>
                                );
                            })}
                        </div>
                    </div>}

                    {/* ABOUT MY STUDENT SECTION */}
                    {/* student name is at least what wee except */}

                    {isParent && (rolePermissions.canViewStudentName || rolePermissions.canViewStudentBio) && !!studentName && (
                        <div className={Classes.sectionHeaderStyles} style={{ paddingBottom: 8 }}>
                            <BigDivider />
                            <h3>About {isMe ? 'Your' : 'My'} Student</h3>
                            {rolePermissions.canViewStudentName && !!studentName && <div className={Classes.infoPairContainer}>
                                <div className={Classes.oneLinerTitle}>Name</div>
                                <span>{studentName}</span>
                            </div>}
                            {rolePermissions.canViewStudentBio && !!studentBio && <div className={Classes.infoPairContainer}>
                                <div className={Classes.oneLinerTitle}>Bio</div>
                                <span>&ldquo;{studentBio}&rdquo;</span>
                            </div>}
                            {rolePermissions.canViewMajor && user.major && <div className={Classes.infoPairContainer}>
                                <div className={Classes.oneLinerTitle}>Major</div>
                                {user.major && <ProfileDetailSpan>{user.major}</ProfileDetailSpan>}
                            </div>}
                            {rolePermissions.canViewIncomingClass && user.incomingClass && <div className={Classes.infoPairContainer}>
                                <div className={Classes.oneLinerTitle}>Incoming Class</div>
                                <span>{user.incomingClass}</span>
                            </div>}
                            {rolePermissions.canViewGraduatingClass && user.graduatingClass && <div className={Classes.infoPairContainer}>
                                <div className={Classes.oneLinerTitle}>Graduating Class</div>
                                <span>{user.graduatingClass}</span>
                            </div>}
                            {rolePermissions.canViewTransfer && !!transfer && <div className={Classes.infoPairContainer}>
                                <span className={Classes.infoLine}><RedoIcon className={Classes.smallIcon} />{user.firstName}{studentInfoIsPrefix} a transfer student {!!transfer.name && `from ${transfer.name}`}</span>
                            </div>}
                        </div>
                    )}

                    {/* COMMUNITY SECTION */}

                    {!!sortedGroups.length && canSeeUsersGroups && <div className={Classes.classesSectionContainer}>
                        <BigDivider />
                        <div className={Classes.sectionHeaderStyles}>
                            <FlexRow style={{ marginBottom: 20 }}>
                                <div>
                                    <h3>{titlePrefix} Groups</h3>
                                </div>
                                {isMe ? <Tooltip
                                    arrow
                                    title='Edit My Groups'
                                    placement='top'
                                    data-focus-outline='radius:30,padding:-2,zIndex:1'
                                >
                                    <EditIconButton
                                        size='large'
                                        onClick={this.openManageMyGroupsDialog}
                                    >
                                        <EditIcon />
                                    </EditIconButton>
                                </Tooltip> : null}
                            </FlexRow>
                        </div>
                        <List className={Classes.classes}>
                            {sortedGroups.map((group) => {

                                const link = gotoGroupLink(group, currentUserClasses);

                                return (
                                    <ClassListItem
                                        className='nearpeer-group-list-item'
                                        key={group.id}
                                        showPrivate
                                        group={group}
                                        showUnreadBadge
                                        titleFontSize={17}
                                        link={link}
                                        data-focus-outline='zIndex:1,radius:5'
                                        middleIcon={<RightArrowIcon />}
                                        push={push}
                                    />
                                );
                            })}
                        </List>
                    </div>}

                    {/* CONNECTIONS SECTION */}

                    {!!peers.length && canSeeUsersConnections && <div className={Classes.sectionHeaderStyles}>
                        {sortedGroups.length === 0 && <BigDivider />}
                        {sortedGroups.length !== 0 && <div style={{ height: 40 }} />}
                        <h3>{titlePrefix} Connections</h3>
                        <ProfileConnectionsList rowHeight={175} cols={this.state.wide ? 3 : 2}>
                            {this.state.shuffledPeers.map((peer) => {

                                const interactionWithPeer = rolesInteractions.find((roleInteraction) => {

                                    return roleInteraction.id === peer.roleId;
                                });

                                // PREVENTING BUG PROBLEM ITS EASIER TO PREVENT TO SEE SOMEONE THAN HAVE AN ERROR IF THERE IS WRONNG SETUP IN DATABASE
                                let canViewProfile = false;
                                if (interactionWithPeer) {
                                    canViewProfile = interactionWithPeer.canViewProfile;
                                }

                                return <ProfileConnectionCard
                                    key={peer.id}
                                    peer={peer}
                                    canViewProfile={canViewProfile}
                                    wide={this.state.wide}
                                    onRestricted={() => {

                                        showNotification('Sorry, you cannot see this user\'s profile');
                                    }}
                                />;
                            })}

                        </ProfileConnectionsList>
                    </div>}

                    {/* End Section*/}
                </div>
                <NotifyUserDialog
                    open={this.state.notifyUserOpen}
                    user={user}
                    onRequestClose={this.closeNotifyUser}
                />
                <ChangeRoleDialog
                    open={this.state.changeRoleOpen}
                    user={user}
                    onRequestClose={this.closeChangeRole}
                />
                <ManageGroupsDialog
                    open={!!this.state.groupManagementOpen}
                    user={user}
                    currentGroups={classes}
                    myCurrentGroups={currentUserClasses}
                    onRequestClose={this.closeManageGroupsDialog}
                    isMe={this.state.groupManagementType === 'ownUser'}
                    debug={debugGroupSorting}
                />
                <MediaViewer
                    isOpen={this.state.mediaViewerOpen}
                    onClose={this.closeMediaViewer}
                    imageUrl={this.state.mediaViewerImageUrl}
                    imageAlt={`${user.firstName}'s profile photo`}
                />
            </Wrapper>
        );
    }
}

module.exports = DetailPage;

internals.SpinnerContainer = Styled.div`
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-contents: center;
    border-radius: 16px;
    background-color: rgba(255, 255, 255, 0.75);
    height: 10rem;
    width: 10rem;
`;

internals.BigDivider = class BigDivider extends React.PureComponent {

    static propTypes = {
        className: T.string
    }

    render() {

        return <div className={`${this.props.className || ''} ${Classes.bigDivider}`} aria-hidden='true' />;
    }
};

internals.UserBadgeGroup = Styled.div`
    display: flex;
    align-items: center;
    margin-top: 10px;
    flex-wrap: wrap;
`;

internals.UserBadgeLabel = Styled.span`
    flex-shrink: 1;
    font-size: 1.2rem;
    color: #595959;
    font-weight: bold;
    margin: 0;

    @media screen and (max-width: 420px) {
        font-size: 1rem;
    }
`;

internals.SchoolLine = Styled.div`
    margin-top: 0;
    margin-bottom: 10px;
    margin-right: 0.5em;
`;

const profileDetailStyles = `
    font-size: 21px;
    margin-top: 0;
    margin-bottom: 0;
    color: #595959;

    @media screen and (max-width: 600px) {
        font-size: 16px;
    }
`;

internals.ProfileDetailLine = Styled.div`${profileDetailStyles}`;

internals.ProfileDetailParagraph = Styled.p`${profileDetailStyles}`;

internals.ProfileDetailSpan = Styled.span`${profileDetailStyles}`;

internals.getPronouns = (gender) => {

    switch (gender) {
        case 'male':
            return 'He/him';
        case 'female':
            return 'She/her';
        case 'nonbinary':
            return 'They/them';
        default:
            return gender;
    }
};

internals.Wrapper = Styled.div`
    width: 100%;

    h3 {
        font-size: 28px;
        margin: 0;
        margin-bottom: 26px;
    }
    h4 {
        font-size: 23px;
        margin: 0;
    }
`;

internals.HeaderTitle = Styled(Typography).attrs({
    variant: 'h2'
})`
    && {
        margin-top: 0;
        margin-bottom: 4px;
        font-size: 32px;
        line-height: 1.08;
        letter-spacing: -0.02em;
        text-overflow: ellipsis;
        overflow: hidden;

        @media screen and (max-width: 600px) {
            font-size: 26px;
        }
    }
`;

internals.TopRowExtras = Styled.div`
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    margin-top: -17px;
    margin-bottom: 10px;
    margin-left: -15px;
    margin-right: -4px;
`;

internals.Header = Styled.div`
    display: flex;
    flex-direction: row nowrap;
    align-items: stretch;
    gap: 28px;
    padding: 24px;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 24px;
    background: ${({ theme }) => theme.palette.background.paper};
    box-shadow: none;

    @media screen and (max-width: 600px) {
        gap: 18px;
        padding: 18px;
        border-radius: 20px;
    }
`;

internals.HeaderLeftSide = Styled.div`
    flex: 0 0 min(42%, 240px);
    max-width: 240px;

    @media screen and (max-width: 600px) {
        flex-basis: 42%;
        max-width: 42%;
    }
`;

internals.HeaderRightSide = Styled.div`
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

internals.EditIconButton = Styled(IconButton)`
    @media screen and (max-width: 600px) {
        padding: 10px;
    }
`;

internals.FlexRow = Styled.div`
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: flex-start;

    h3 {
        padding-top: 3px;
        margin-bottom: 0;
    }
`;

internals.InterestHelperText = Styled(Typography)`
    && {
        margin-top: -4px;
        margin-bottom: 18px;
        font-style: italic;
        color: #595959;
        width: 45%;

        @media screen and (max-width: 600px) {
            font-size: 16px;
            width: 40%;
        }
    }
`;

internals.styles = {
    icon: {
        fill: '#ffa6c4'
    }
};

internals.StyledBackdrop = Styled(Backdrop)`
    && {
        z-index: 2000;
        background-color: rgba(0, 0, 0, 0.2);
    }
`;

internals.InterestChip = InterestChip;

internals.CameraButton = Styled.button`
    margin: 10px;
    padding: 8px 24px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;

    &.primary {
        border: none;
        background: ${({ theme }) => theme.palette.primary.main};
        color: white;
    }

    &.secondary {
        border: 1px solid #ccc;
        background: white;
    }
`;

internals.PassionsHolder = Styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    flex: 0 1 auto;
`;

internals.SchoolInfo = Styled.div`
    margin-top: 20px;

    @media screen and (max-width: 600px) {
        margin-top: 12px;
    }
`;

internals.StyledImageRequestBtn = Styled(FlatButton)`
    && {
        width: 150px;
        line-height: 32px !important;
        width: 48% !important;
        &:first-of-type {
            margin-right: 2% !important;
        }
        &:last-of-type {
            margin-left: 2% !important;
        }
    }
`;

internals.ConnectButton = Styled(FlatButton, transient$Props)`
    && {
        color: ${({ theme, $isChat }) => $isChat ? theme.palette.secondary.contrastText : theme.palette.primary.contrastText};
        background-color: ${({ theme, $isChat }) => $isChat ? theme.palette.secondary.main : theme.palette.primary.main};
        border: none;
        border-radius: 999px;
        box-shadow: none;
        font-family: ${Fonts.headerFont};
        font-weight: bold;
        text-transform: none;
        font-size: 1.2rem;
        letter-spacing: 0;
        line-height: 1.2;
        min-height: 44px;
        height: auto;
        margin: 0;

        &:hover {
            background-color: ${({ theme, $isChat }) => $isChat ? theme.palette.secondary.dark : theme.palette.primary.dark};
            box-shadow: none;
        }

        &.Mui-disabled {
            background-color: rgba(0, 0, 0, 0.12);
            color: rgba(0, 0, 0, 0.26);
        }
    }
`;

internals.UserBadge = Styled(UserBadgeComponent)`
    margin-right: 10px;
    flex-shrink: 0;
`;
